<script lang="ts">
	import { Dialog as DialogPrimitive } from "bits-ui";
	import Cross2 from "svelte-radix/Cross2.svelte";
	import { cn } from "$lib/utils.js";

	type $$Props = DialogPrimitive.CloseProps;
	let className: $$Props["class"] = undefined;
	export { className as class };
</script>

<DialogPrimitive.Close
	class={cn(
		"absolute right-2 top-2 rounded-sm ring-offset-background transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
		className
	)}
>
	<Cross2 class="h-8 w-8" />
	<span class="sr-only">Close</span>
</DialogPrimitive.Close>
